import { render, staticRenderFns } from "./jifen-record.vue?vue&type=template&id=31cd25a2&scoped=true&"
import script from "./jifen-record.vue?vue&type=script&lang=js&"
export * from "./jifen-record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cd25a2",
  null
  
)

export default component.exports